import React from "react";
import { Script } from "gatsby";

import Cursor from "components/cursor";
import ScrollToTop from "components/scrollToTop";
import LoadingScreen from "components/Loading-Screen";

import "styles/main.css";
import "styles/preloader.css";

const LightTheme = ({ children, mobileappstyle, useSkin }) => {
  React.useEffect(() => {
    window.theme = "light";
    if (mobileappstyle) {
      let mobileAppCssLink = document.createElement("link");
      mobileAppCssLink.rel = "stylesheet";
      mobileAppCssLink.href = "/css/mobile-app-light.css";
      document.head.appendChild(mobileAppCssLink);
    }

    if (useSkin) {
      let skinCssLink = document.createElement("link");
      skinCssLink.rel = "stylesheet";
      skinCssLink.href = "/css/arch-skin-light.css";
      document.head.appendChild(skinCssLink);
    }
  }, [mobileappstyle, useSkin]);

  return (
    <>
      <Cursor />
      {children}
      <ScrollToTop />

      <Script defer src="/js/wowInit.js"></Script>
    </>
  );
};

export default LightTheme;
